function pad(num, size) {
    var s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
}

function createTimeObjectFrom(hours, minutes) {
    // Start Time:
    let startTime = new Date();
    startTime.setHours(hours);
    startTime.setMinutes(minutes);
    startTime.setSeconds(0);
    startTime.setMilliseconds(0);

    let now = new Date();
    let diff = now.getTime() - startTime.getTime();
    if (diff < 0) {
        startTime.setDate(startTime.getDate() - 1);
    }

    return startTime;
}

export default {
    pad,
    createTimeObjectFrom
}
